import { Injectable } from "@angular/core";
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { DataSearchService } from '../services/data-search.service';
import { IndividualConfig, ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: "root",
})
export class LatestLocationCarResolver implements Resolve<boolean> {

  constructor(private dataSearchService: DataSearchService,
              private router: Router,
              private toastr: ToastrService) {}
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    
    
    if(this.dataSearchService.address == undefined) {
      
      this.toastr.show(
        'Oups, Une erreur est survenue lors de l\'execution',
        'Réesayez Réesayer',
        {
          timeOut: 5000,
          closeButton: true,
        } as IndividualConfig,
        'toast-' + 'error'
      )
      
      this.router.navigate(['/']);

      return of(false);

    } else {
      
      return of(true);

    }
  }
}
